import * as React from "react";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Loader } from "../Views/Loader";
import {
  Form,
  CreateBase,
  useCreateContext,
  useNotify,
  useDataProvider,
  useRefresh,
  useStore,
  useGetIdentity,
  useListContext,
} from "react-admin";

const SubmitForm = ({ handleClose, children, resource }) => {
  // const [userBalance, setUserBalance] = useStore("userBalance", 0);
  const [userBalanceCall, setUserBalanceCall] = useStore(
    "userBalanceCall",
    false
  );
  const { data: userIdentity } = useGetIdentity();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const { save } = useCreateContext();
  const notify = useNotify();

  const [loading, setLoading] = React.useState(false);

  // Define messages based on resource
  const successMessages = {
    users: "User created successfully!",
    rechargeRecords: "Recharged successfully!",
    redeemRecords: "Redeemed successfully!",
    gameCatalogue: "Game created successfully!",
  };

  const handleSubmit = async (data) => {
    const transformedData = {
      ...data,
      ...(resource === "users" && {
        phone: data.phone ? Number(data.phone) : null,
      }),
      ...(resource === "rechargeRecords" && {
        amount: data.amount ? Number(data.amount) : null,
      }),
      ...(resource === "redeemRecords" && {
        amount: data.amount ? Number(data.amount) : null,
      }),
      ...(resource === "gameCatalogue" && {
        RTP: data.RTP ? Number(data.RTP) : null,
      }),
    };

    setLoading(true);
    try {
      const response = await dataProvider.create(resource, {
        data: transformedData,
      });

      if (response) {
        notify(successMessages[resource] || "Operation successful!", {
          type: "success",
        });
        if (userIdentity?.userRoleName !== "Super-User") {
          if (resource === "rechargeRecords") {
            // setUserBalance(
            //   (prevBalance) => prevBalance - transformedData.amount
            // );
            setUserBalanceCall(true);
          }
          if (resource === "redeemRecords") {
            // setUserBalance(
            //   (prevBalance) => prevBalance + transformedData.amount
            // );
            setUserBalanceCall(true);
          }
        }

        handleClose();
        refresh();
      }
    } catch (error) {
      notify(error.message, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Form
        noValidate
        onSubmit={handleSubmit}
        sx={{ mt: 3, alignSelf: "stretch" }}
      >
        {children}
      </Form>
    </>
  );
};

export const CreateForm = ({
  title,
  handleClose,
  children,
  record,
  resource,
  submitDisabled = false,
}) => {
  return (
    <CreateBase record={record} resource={resource}>
      <Container component="overlay" maxWidth="sm" sx={{ p: 3 }} >
        <Box
          className="overlayFormBox"
          sx={{
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            "& .MuiInputLabel-root": {
              textAlign: "left",
              fontSize: "0.75em",
            },
            "& .MuiButton-root": { textTransform: "capitalize" },
            "& .MuiGrid-item": {
              // display: "flex",
              // flexDirection: "row",
              gap: 1,
              // alignItems: "center",
              // justifyContent: "flex-end",
            },
            "& .MuiTextField-root": {
              flexBasis: "75%",
              alignItems: "stretch",
            },
            "& .MuiAutocomplete-root": {
              flexBasis: "75%",
              alignItems: "stretch",
            },
          }}
        >
          <Typography component="h1" variant="h6" sx={{ mb: 3 }}>
            {title}
          </Typography>
          <SubmitForm handleClose={handleClose} resource={resource}>
            <Grid container>{children}</Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    border: "1px solid rgba(255, 239, 153, 0.20)",
                    color: "#FFF",
                    "&:hover": {
                      border: "1px solid #fff",
                      background: "none",
                    },
                  }}
                  onClick={handleClose}
                >
                  cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={submitDisabled}
                  sx={{
                    backgroundColor: "#FFD700",
                    color: "#000",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: "#FFA000",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "rgba(255, 215, 0, 0.35)",
                      color: "rgba(0, 0, 0, 0.6)",
                    },
                  }}
                >
                  confirm
                </Button>
              </Grid>
            </Grid>
          </SubmitForm>
        </Box>
      </Container>
    </CreateBase>
  );
};
